import { NextSeo } from 'next-seo';
import PropTypes from 'prop-types';

import AssembleLayout from '@/src/layouts/AssembleLayout';
import MainLayout from '@/src/layouts/MainLayout';
import { successCaseArticleByUIDGet, successCaseArticlesGet } from '@/src/lib/prismic/queries';
import { urlHostResolver } from '@/src/lib/utils';
import SuccessCasesArticle from '@/src/views/success-cases/SuccessCasesArticle';

function SuccessCasesDetailsPage({ doc, latest, preview }) {
  const coverImage = doc?.data?.cover;
  const ogImage = {
    url: coverImage?.url,
    width: coverImage?.dimensions?.width,
    height: coverImage?.dimensions?.height,
    alt: `${coverImage?.alt} | Casos de sucesso`,
  };

  return (
    <AssembleLayout
      Layout={MainLayout}
      Component={SuccessCasesArticle}
      doc={doc}
      latest={latest}
      preview={preview}>
      <NextSeo
        title={`${doc?.data?.title} | Casos de sucesso`}
        description={doc?.data?.subtitle}
        openGraph={{
          title: `${doc?.data?.title} | Casos de sucesso`,
          url: urlHostResolver(`/success-cases/article/${doc?.uid}`),
          images: [...(coverImage ? [ogImage] : [])], // TODO: Must find a more readable solution
        }}
      />
    </AssembleLayout>
  );
}

SuccessCasesDetailsPage.propTypes = {
  doc: PropTypes.object,
  latest: PropTypes.object,
  preview: PropTypes.bool,
};

export async function getStaticPaths() {
  return { paths: [], fallback: 'blocking' };
}

export async function getStaticProps(context) {
  const { params, preview = false, previewData = {} } = context;
  const { ref } = previewData;
  const { articleSlug: successCaseArticleUid } = params;

  const docGraphQuery = `{
    success-cases-article {
      cover
      title
      subtitle
      content
      date
      author {
        name
        avatar
      }
    }
  }`;

  const doc = await successCaseArticleByUIDGet({
    successCaseArticleUid,
    graphQuery: docGraphQuery,
  });

  if (!doc) return { notFound: true };

  const articlesGraphQuery = `{
    success-cases-article {
      cover
      title
      subtitle
      date
      author {
        name
        avatar
      }
    }
  }`;

  const latest = await successCaseArticlesGet({ graphQuery: articlesGraphQuery }, { ref });

  return {
    props: { doc, latest, preview },
    revalidate: 180,
  };
}

export default SuccessCasesDetailsPage;
